goog.provide("shadow.js.shim.module$dayjs$locale$es");
goog.provide("module$shadow_js_shim_module$dayjs$locale$es");
shadow.js.shim.module$dayjs$locale$es = shadow.js.nativeProvides["dayjs/locale/es"] = require("dayjs/locale/es");
module$shadow_js_shim_module$dayjs$locale$es.default = shadow.js.shim.module$dayjs$locale$es;
